import { ChangeDetectionStrategy, Component, Input, output, inject } from '@angular/core';

import {
  DividerComponent,
  HeadingComponent,
  IconButtonComponent,
  IconComponent,
  IconHelpComponent,
  MessageComponent,
  RtTooltip,
} from '@core/user-interface-legacy';

import type { DynamicFormGroup } from './dynamic-form-group';
import { DynamicHelpers } from '../../../helpers';
import type { AnyDynamicInput, DynamicGroupConfig, DynamicText } from '../../../types';
import { DynamicListInfoComponent } from '../../dynamic-list-info/dynamic-list-info.component';
import { DynamicFormInputComponent } from '../dynamic-form-input/dynamic-form-input.component';

@Component({
  selector: 'rti-dynamic-form-group',
  templateUrl: './dynamic-form-group.component.html',
  styleUrls: ['./dynamic-form-group.component.less'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DividerComponent,
    DynamicFormInputComponent,
    DynamicListInfoComponent,
    HeadingComponent,
    IconButtonComponent,
    IconComponent,
    IconHelpComponent,
    MessageComponent,
    RtTooltip,
  ],
})
export class DynamicFormGroupComponent {
  public readonly helpers = inject(DynamicHelpers);

  @Input() public group: DynamicFormGroup;

  public remove = output<DynamicFormGroup>();

  public buildText(text: DynamicText): string {
    return this.helpers.buildText(text);
  }

  public trackInput(index: number, input: DynamicFormGroup['inputs'][0]): string | number {
    return (<DynamicGroupConfig>input.config)?.checksum || index;
  }

  public isHidden(input: AnyDynamicInput): boolean {
    return !!('hidden' in input.config && input.config.hidden);
  }

  public clickRemove(): void {
    this.remove.emit(this.group);
  }
}
